// extracted by mini-css-extract-plugin
export default {"reclamationContainer":"Reclamation_reclamationContainer__lDHk9"};